module.exports = __webpack_public_path__ + "img/generalJobs.f989ba05.svg";